export const PLANS = "/plans";
export const BILLING = "/billing";
export const MEMBERS = "/members";
export const VERIFY_EMAIL = "/verify-email";
export const PRICING_SUMMARY = "/pricing-summary";
export const LICENSE = "/license";
export const UPGRADE_PLAN = "/upgrade-plan";
export const SUPPORT_ACCESS = "/support-access";
export const SECURITY_REPORTS = "/security-reports";
export const ACCOUNT_SETTINGS = "/account";
